// On-screen driving controls (touch): steer left/right, gas, brake. Keyboard: WASD / arrows.
import { driveInput, phoneOpen, playerLoc } from "../bridge";

function Pedal({ label, onDown, onUp, cls }: { label: string; onDown(): void; onUp(): void; cls: string }) {
  return (
    <button
      class={`pedal ${cls}`}
      onPointerDown={(e) => {
        try {
          (e.currentTarget as HTMLElement).setPointerCapture(e.pointerId);
        } catch {
          /* pointer already gone (cancelled touch): still press */
        }
        onDown();
      }}
      onPointerUp={onUp}
      onPointerCancel={onUp}
      onContextMenu={(e) => e.preventDefault()}
    >
      {label}
    </button>
  );
}

export function DrivePad() {
  if (!playerLoc.value.driving || phoneOpen.value) return null;
  return (
    <div class="drive-pad" aria-label="Driving controls">
      <div class="steer">
        <Pedal label="◀" cls="steer-l" onDown={() => (driveInput.steer = -1)} onUp={() => (driveInput.steer = 0)} />
        <Pedal label="▶" cls="steer-r" onDown={() => (driveInput.steer = 1)} onUp={() => (driveInput.steer = 0)} />
      </div>
      <div class="gas">
        <Pedal label="🛑" cls="brake" onDown={() => (driveInput.throttle = -1)} onUp={() => (driveInput.throttle = 0)} />
        <Pedal label="⛽" cls="throttle" onDown={() => (driveInput.throttle = 1)} onUp={() => (driveInput.throttle = 0)} />
      </div>
    </div>
  );
}
